import React, { useState, useContext, useEffect } from "react";
import { Modal } from "../../../components/common/Modal";
import { DContext } from "../../../context/Datacontext";
import ProPlayer from "../../../components/blocks/ProPlayer";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { BsCameraVideoFill } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CiImageOn } from "react-icons/ci";
import { AiOutlineFilePdf } from "react-icons/ai";
import { TbFileDescription } from "react-icons/tb";
import { FiEdit } from "react-icons/fi";
import { updateCourse, deleteModule } from "../../../services/coures/createCourse";
import { VideoDuration } from "../../../utils/VideoDuration";

export default function CurriculumLayout({
    course,
    onCreateSyllabus,
    onAddSession,
    onUpdateSession,
    addingSessionState = {},
    onRefreshCourse,
    onDeleteSession,
    setCourse
}) {
    const { BeURL, showAlert } = useContext(DContext);

    const [openSections, setOpenSections] = useState(null);
    const [activeSession, setActiveSession] = useState(null);

    // Syllabus modal
    const [syllabusPopup, setSyllabusPopup] = useState(false);
    const [newSyllabusName, setNewSyllabusName] = useState("");
    const [order, setOrder] = useState("");
    const [creatingSyllabus, setCreatingSyllabus] = useState(false);

    const [syllabusTouched, setSyllabusTouched] = useState({});
    const [syllabusErrors, setSyllabusErrors] = useState({});

    // Session modal (per-syllabus)
    const [sessionPopupFor, setSessionPopupFor] = useState(null);

    // session form state
    const [sessionTitle, setSessionTitle] = useState("");
    const [sessionDescription, setSessionDescription] = useState("");
    const [sessionType, setSessionType] = useState("");
    const [sessionDuration, setSessionDuration] = useState("");
    const [videoFile, setVideoFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [uploadingSession, setUploadingSession] = useState(false);

    const [sessionTouched, setSessionTouched] = useState({});
    const [sessionErrors, setSessionErrors] = useState({});

    const [selectedSyllabusId, setSelectedSyllabusId] = useState("");
    const [editModule, setEditModule]=useState({})

    // ---------------- Syllabus validation ----------------
    const validateSyllabusField = (name, value) => {
        let error = "";

        if (name === "name") {
            if (!value || !value.trim()) {
                error = "Syllabus name is required";
            } else if (value.trim().length < 3) {
                error = "Minimum 3 characters required";
            }
        }

        if (name === "order") {
            if (value === "" || value === null || value === undefined) {
                error = "Order number is required";
            } else if (Number(value) <= 0 || !Number.isFinite(Number(value))) {
                error = "Order must be a number greater than 0";
            }
        }

        return error;
    };

    const handleNameChange = (e) => {
        const value = e.target.value;
        setNewSyllabusName(value);
        setSyllabusTouched((prev) => ({ ...prev, name: true }));
        const err = validateSyllabusField("name", value);
        setSyllabusErrors((prev) => ({ ...prev, name: err }));
    };

    
    // const handleOrderChange = (e) => {
    //     const value = e.target.value;
    //     // allow empty string or numeric
    //     setOrder(value);
    //     setSyllabusTouched((prev) => ({ ...prev, order: true }));
    //     const err = validateSyllabusField("order", value);
    //     setSyllabusErrors((prev) => ({ ...prev, order: err }));
    // };

    const getSyllabusInputClass = (name) => {
        if (!syllabusTouched[name]) return "border-gray-300";
        if (syllabusErrors[name]) return "border-red-500";
        return "border-green-500";
    };

    const renderSyllabusError = (name) => {
        if (!syllabusTouched[name] || !syllabusErrors[name]) return null;
        return <p className="text-xs text-red-500 mt-1">{syllabusErrors[name]}</p>;
    };

    const handleCreateSyllabus = async () => {
        const nameError = validateSyllabusField("name", newSyllabusName);

        setSyllabusTouched({ name: true, order: true });
        setSyllabusErrors({ name: nameError });

        if (nameError) return;

        try {
            setCreatingSyllabus(true);

            const createdId = await onCreateSyllabus(
                newSyllabusName.trim(),
                Number(order)
            );

            if (createdId) {
                setOpenSections((prev) => ({ ...prev, [createdId]: true })); 
            }

            setNewSyllabusName("");
            setOrder("");
            setSyllabusTouched({});
            setSyllabusErrors({});
            setSyllabusPopup(false);

            if (onRefreshCourse) onRefreshCourse();
        } catch (err) {
            console.error("create syllabus error:", err);
        } finally {
            setCreatingSyllabus(false);
        }
    };

    const handleUpdateSyllabus = async (editSyllabus) => {
        try {
            if (!editSyllabus?.courseId || !editSyllabus?.syllbusId) {
                alert("Course ID or Syllabus ID missing")
                return
            }

            let syllabusId = editSyllabus.syllbusId || ""

            const result = await updateCourse(
                BeURL,
                editSyllabus.courseId,
                syllabusId,
                {
                    name: newSyllabusName
                }
            )
            alert(result?.message)

            if (result?.success) {
                setCourse(result?.course)
                handleCloseModule()
            }
        }
        catch (err) {
            console.log("Error in Edit Module", err)
        }
    }

    const handleDeleteModule = async (courseId, syllabusId) => {
        try {

            if (!courseId || !syllabusId) {
                alert("Course ID or Syllabus ID missing")
                return
            }

            const result = await deleteModule(
                BeURL,
                courseId,
                syllabusId
            )

            alert(result?.message)

            if (result?.success) {
                setCourse(result?.course)
            }

        }
        catch (err) {
            console.log("Error in Delete Module", err)
        }
    }


    const handleEditSession = (courseId ,syllabusId, assetId) => {
        setEditModule({courseId, syllabusId,assetId,type: "Edit"})
        openSessionModal(String(course.syllabuses[0].id))
    }


    // ---------------- Session validation ----------------
    const resetSessionForm = () => {
        setSessionTitle("");
        setSessionDescription("");
        setSessionType("");
        setSessionDuration("");
        setVideoFile(null);
        setPdfFile(null);
        setImageFile(null);
        setSessionTouched({});
        setSessionErrors({});
    };

    const openSessionModal = (syllabusId) => {
        setSessionPopupFor(syllabusId);
        resetSessionForm();
    };

    const closeSessionModal = () => {
        setSessionPopupFor(null);
        resetSessionForm();
        setEditModule({})
    };

    const validateSessionField = (name, value) => {
        let error = "";

        if (name === "title") {
            if (!value || !value.trim()) error = "Session title is required";
            else if (value.trim().length < 3) error = "Title must be at least 3 characters";
        }

        if (name === "type") {
            if (!value || !value.trim()) error = "Session type is required";
        }

        if (name === "duration") {
            if (value === "" || value === null || value === undefined) return "";
            const n = Number(value);
            if (!Number.isFinite(n) || n < 0) error = "Duration must be 0 or greater";
        }

        if (name === "videoFile") {
            if (sessionType === "video") {
                if (!value) error = "Video file is required for video sessions";
                else if (!value.type.startsWith("video/")) error = "Please upload a valid video file";
            }
        }

        if (name === "pdfFile") {
            if (sessionType === "pdf") {
                if (!value) error = "PDF file is required for pdf sessions";
                else if (value.type !== "application/pdf") error = "Please upload a valid PDF file";
            }
        }

        if (name === "imageFile") {
            if (sessionType === "image") {
                if (!value) error = "Image file is required for image sessions";
                else if (!value.type.startsWith("image/")) error = "Please upload a valid image file";
            }
        }

        return error;
    };

    // field change handlers with realtime validation
    const handleSessionTitleChange = (e) => {
        const val = e.target.value;
        setSessionTitle(val);
        setSessionTouched((prev) => ({ ...prev, title: true }));
        const err = validateSessionField("title", val);
        setSessionErrors((prev) => ({ ...prev, title: err }));
    };

    const handleSessionDescriptionChange = (e) => {
        const val = e.target.value;
        setSessionDescription(val);
    };

    const handleSessionTypeChange = (e) => {
        const val = e.target.value;
        setSessionType(val);
        // reset files on type change
        setVideoFile(null);
        setPdfFile(null);
        setImageFile(null);
        // set touched + validate type
        setSessionTouched((prev) => ({ ...prev, type: true }));
        const err = validateSessionField("type", val);
        setSessionErrors((prev) => ({ ...prev, type: err, videoFile: "", pdfFile: "", imageFile: "" }));
    };

    // const handleSessionDurationChange = (e) => {
    //     const val = e.target.value;
    //     setSessionDuration(val);
    //     setSessionTouched((prev) => ({ ...prev, duration: true }));
    //     const err = validateSessionField("duration", val);
    //     setSessionErrors((prev) => ({ ...prev, duration: err }));
    // };

    const handleSessionFileChange = (e, kind) => {
        const file = e.target.files?.[0] ?? null;

        if (kind === "video") {
            setVideoFile(file);
            setSessionTouched((prev) => ({ ...prev, videoFile: true }));
            const err = validateSessionField("videoFile", file);
            setSessionErrors((prev) => ({ ...prev, videoFile: err }));
        } else if (kind === "pdf") {
            setPdfFile(file);
            setSessionTouched((prev) => ({ ...prev, pdfFile: true }));
            const err = validateSessionField("pdfFile", file);
            setSessionErrors((prev) => ({ ...prev, pdfFile: err }));
        } else if (kind === "image") {
            setImageFile(file);
            setSessionTouched((prev) => ({ ...prev, imageFile: true }));
            const err = validateSessionField("imageFile", file);
            setSessionErrors((prev) => ({ ...prev, imageFile: err }));
        }
    };

    const getAssetIcon = (type) => {
        switch (type) {
            case "video":
                return <BsCameraVideoFill />;
            case "image":
                return <CiImageOn />;
            case "pdf":
                return <AiOutlineFilePdf />;
            case "description":
                return <TbFileDescription />; // nice description icon
            default:
                return null;
        }
    };

    const getSessionInputClass = (name) => {
        if (!sessionTouched[name]) return "border-gray-300";
        if (sessionErrors[name]) return "border-red-500";
        return "border-green-500";
    };

    const renderSessionError = (name) => {
        if (!sessionTouched[name] || !sessionErrors[name]) return null;
        return <p className="text-xs text-red-500 mt-1">{sessionErrors[name]}</p>;
    };

    const handleCreateSession = async () => {
        if (uploadingSession) return;

        const syllabusId = selectedSyllabusId || sessionPopupFor;
        if (!syllabusId) {
            showAlert("Invalid syllabus");
            return;
        }

        // validate all session fields
        const titleErr = validateSessionField("title", sessionTitle);
        const typeErr = validateSessionField("type", sessionType);
        const durationErr = validateSessionField("duration", sessionDuration);
        const videoErr = validateSessionField("videoFile", videoFile);
        const pdfErr = validateSessionField("pdfFile", pdfFile);
        const imageErr = validateSessionField("imageFile", imageFile);

        setSessionTouched({
            title: true,
            type: true,
            duration: true,
            videoFile: true,
            pdfFile: true,
            imageFile: true,
        });

        setSessionErrors({
            title: titleErr,
            type: typeErr,
            duration: durationErr,
            videoFile: videoErr,
            pdfFile: pdfErr,
            imageFile: imageErr,
        });

        // collect final validation result depending on type
        const hasFieldErrors = [titleErr, typeErr, durationErr].some(Boolean);
        let fileOk = true;
        if (sessionType === "video") fileOk = !videoErr;
        if (sessionType === "pdf") fileOk = !pdfErr;
        if (sessionType === "image") fileOk = !imageErr;

        if (hasFieldErrors || !fileOk) {
            return; // show errors and stop
        }

        try {
            setUploadingSession(true);

            // call onAddSession - it should accept files and build FormData
            await onAddSession(
                syllabusId,
                sessionTitle.trim(),
                sessionDescription?.trim() || "",
                sessionType.trim(),
                sessionDuration ? Number(sessionDuration) : 0,
                videoFile,
                // pass pdf or image in the appropriate params (adjust onAddSession if needed)
                sessionType === "pdf" ? pdfFile : null,
                sessionType === "image" ? imageFile : null
            );

            // show success and close
            // (you can replace showalert with a nicer toast in your app)
            showAlert("Session created successfully");
            closeSessionModal();
        } catch (err) {
            console.error("create session error:", err);
            showAlert(err?.message);
        } finally {
            setUploadingSession(false);
        }
    };

    const deleteSession = async (syllabusId, sessionId) => {
        try {
            await onDeleteSession(syllabusId, sessionId);
        } catch (error) {
            console.error("Delete session error FULL:", error);
            showAlert(error?.message);
        }
    };

    const handleEditModule = (courseId,syllbusId) => {
          if(!courseId){
            alert("Course id is required")
          }

          if(!syllbusId){
            alert("Syllbus id required")
          }

          let type = "Edit"

        setSyllabusPopup(true)
        setEditModule({ courseId, syllbusId, type})
    }

    useEffect(() => {
        // Only run this logic if we are actively trying to EDIT
        if (editModule.type !== "Edit") return;

        // Find the specific syllabus item in your array by its ID
        const currentSyllabus = course?.syllabuses?.find((s) => s.id === editModule.syllbusId);
        if (currentSyllabus) {
            // Populate your edit state with the found item's details
            setNewSyllabusName(currentSyllabus?.name);
        }
    }, [ editModule, course]);



    useEffect(()=>{
        // Only run this logic if we are actively trying to EDIT
        if (editModule.type !== "Edit") return;

        // Find the specific syllabus item in your array by its ID
        const currentSyllabus = course?.syllabuses?.find((s) => s.id === editModule.syllabusId);
        if (currentSyllabus) {
            // Populate your edit state with the found item's details
            setSelectedSyllabusId(currentSyllabus?.id);
        }

        const currentAssets = currentSyllabus?.assets.find((ass) => ass?._id === editModule?.assetId)
        console.log("currentAssets", currentAssets)
        if(currentAssets){
            setSessionTitle(currentAssets?.title)
            setSessionDescription(currentAssets?.description)
            setSessionType(currentAssets?.type)
            setVideoFile(currentAssets?.file)

        }

    }, [editModule, course])


    const handleUpdateSession = async () => {
        if (uploadingSession) return;

        const syllabusId = selectedSyllabusId || sessionPopupFor;

        if (!syllabusId || !editModule?.assetId) {
            showAlert("Invalid session details");
            return;
        }

        // validate fields
        const titleErr = validateSessionField("title", sessionTitle);
        const typeErr = validateSessionField("type", sessionType);
        const durationErr = validateSessionField("duration", sessionDuration);

        // validate files only if newly selected
        const videoErr =
            sessionType === "video" && videoFile
                ? validateSessionField("video", videoFile)
                : "";

        const pdfErr =
            sessionType === "pdf" && pdfFile
                ? validateSessionField("pdf", pdfFile)
                : "";

        const imageErr =
            sessionType === "image" && imageFile
                ? validateSessionField("image", imageFile)
                : "";

        setSessionTouched({
            title: true,
            type: true,
            duration: true,
            videoFile: true,
            pdfFile: true,
            imageFile: true,
        });

        setSessionErrors({
            title: titleErr,
            type: typeErr,
            duration: durationErr,
            videoFile: videoErr,
            pdfFile: pdfErr,
            imageFile: imageErr,
        });

        const hasFieldErrors = [titleErr, typeErr, durationErr].some(Boolean);

        let fileOk = true;

        if (sessionType === "video") fileOk = !videoErr;
        if (sessionType === "pdf") fileOk = !pdfErr;
        if (sessionType === "image") fileOk = !imageErr;

        if (hasFieldErrors || !fileOk) {
            return;
        }

        try {
            setUploadingSession(true);

            await onUpdateSession(
                syllabusId,
                editModule.assetId, // session id
                sessionTitle.trim(),
                sessionDescription?.trim() || "",
                sessionType.trim(),
                sessionDuration ? Number(sessionDuration) : 0,
                videoFile || null,
                sessionType === "pdf" ? pdfFile || null : null,
                sessionType === "image" ? imageFile || null : null
            );

            showAlert("Session updated successfully");

            closeSessionModal();
        } catch (err) {
            console.error("update session error:", err);
            showAlert(err?.message || "Failed to update session");
        } finally {
            setUploadingSession(false);
        }
    };


    useEffect(() => {
        if (
            course?.syllabuses?.length > 0 &&
            course.syllabuses[0]?.assets?.length > 0 &&
            !activeSession
        ) {
            const firstSyllabus = course.syllabuses[0];
            const firstAsset = firstSyllabus.assets[0];

            setActiveSession({
                ...firstAsset,
                syllabusId: firstSyllabus.id,
                index: 1,
            });
        }
    }, [course, activeSession]);


    const handleCloseModule = () => {
        setSyllabusPopup(false) 
        setNewSyllabusName()
        setEditModule({})
    }

    // ---------- small helpers for UI (no logic change) ----------
    const hasSyllabuses = Array.isArray(course?.syllabuses) && course.syllabuses.length > 0;

    return (
        <div className="flex flex-col gap-6 rounded-2xl">

            {/* ================= PREVIEW PANEL (center top big) ================= */}
            <div className="flex flex-col md:flex-row gap-3 overflow-hidden">
                <div className="flex items-center w-full  rounded-xl justify-center">
                    {!activeSession && (
                        <p className="text-gray-500 text-sm text-center">Select a session below</p>
                    )}
                    {activeSession?.type === "video" &&
                        activeSession?.file?.url && (
                        <div className="w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[650px] rounded-xl overflow-hidden ">
                                <ProPlayer
                                    course={course}
                                    session={activeSession}
                                    BeURL={BeURL}
                                />
                            </div>
                        )}

                    {activeSession?.type === "image" && (
                        <img
                            src={activeSession.file?.url}
                            alt=""
                            className="max-h-[65vh] w-auto rounded-xl shadow"
                        />
                    )}

                    {activeSession?.type === "pdf" && (
                        <iframe
                            title="pdf"
                            src={`${BeURL}${activeSession?.file?.url}`}
                            className="w-full h-[70vh] rounded-xl bg-white border"
                        />
                    )}

                    {activeSession?.type === "description" && (
                        <div className="bg-white p-6 rounded-xl shadow max-w-3xl text-gray-700 text-sm sm:text-base">
                            {activeSession.description}
                        </div>
                    )}
                </div>

                {/* ================= MIDDLE LAYOUT : left column with sessions ================= */}
                <div className="bg-white border w-full md:w-[900px] rounded-2xl shadow-sm overflow-hidden">

                    {/* Header for left panel (with an optional back link if viewing a session) */}
                    <div className="px-5 py-4 border-b bg-white flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            {activeSession ? (
                                <>
                                    <button onClick={() => setActiveSession(null)} className="text-primary-600 text-sm">← Back to sessions</button>
                                    <div className="border-l pl-4">
                                        <h3 className="text-sm font-semibold text-gray-800">Session {activeSession?.index ?? ""}</h3>
                                    </div>
                                </>
                            ) : (
                                <h3 className="text-sm font-semibold text-gray-800">Modules</h3>
                            )}
                        </div>

                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setSyllabusPopup(true)}
                                className="px-3 py-1.5 text-xs font-medium bg-primary-600 text-white rounded-md shadow hover:scale-[1.04] transition"
                            >
                                + Module
                            </button>
                            {/* Add Lesson (opens session modal for first syllabus if exists) */}
                            <button
                                onClick={() => {
                                    if (!hasSyllabuses) {
                                        showAlert("Please create a module");
                                        return;
                                    }
                                    // open modal for first syllabus by default
                                    openSessionModal(String(course.syllabuses[0].id));
                                }}
                                className="px-3 py-1.5 text-xs font-medium bg-primary-50 text-primary-600 rounded-md border border-primary-100"
                            >
                                + Add Session
                            </button>
                        </div>
                    </div>


                    <div className="max-h-[500px] overflow-y-auto">
                        {course?.syllabuses?.map((s, index) => {
                            const isOpen = openSections === String(s.id);
                            const totalSessions = s.assets?.length || 0;

                            return (
                                <div key={s.id} className="border-b border-white/40">

                                    {/* ===== Section Header ===== */}
                                    <div className="flex items-center justify-between w-full">

                                        {/* Main Toggle Button */}
                                        <div
                                            onClick={() =>
                                                setOpenSections((prev) =>
                                                    prev === String(s.id) ? null : String(s.id)
                                                )
                                            }
                                            className="flex-1 px-5 py-4 flex items-start justify-between hover:bg-white/60 transition group"
                                        >
                                            <div className="flex gap-3 items-start">

                                                {/* Index Badge */}
                                                <div className="h-5 p-2 flex items-center justify-center bg-black text-white rounded-md text-xs font-semibold">
                                                    {index + 1}
                                                </div>

                                                <div className="text-left">
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {s.name}
                                                    </p>

                                                    {/* Duration Badge */}
                                                    <div className="flex items-center gap-2 mt-1">
                                                        <span className="text-[11px] px-2 py-[2px] bg-primary-50 text-primary-600 rounded-full">
                                                            {totalSessions} Sessions
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Chevron */}
                                            <div className="flex space-x-2"> 
                                                <button
                                                    className={`transition-transform duration-300 ${isOpen ? "rotate-180 " : "text-green-500"
                                                        }`}
                                                >
                                                    <MdOutlineKeyboardArrowDown />
                                                </button>
                                                {/* Edit Button */}
                                                <button onClick={() => handleEditModule(course?._id,s.id)} className=" text-primary-600 hover:text-primary-700">
                                                    <FiEdit />
                                                </button>
                                                <button onClick={() => handleDeleteModule(course?._id, s.id)} className=" text-red-600 hover:text-red-700">
                                                    <RiDeleteBin6Line />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ===== Session List ===== */}
                                    {isOpen && (
                                        <div className="px-4 pb-4 space-y-2 animate-[fadeIn_.25s_ease]">
                                            {s.assets?.map((asset, i) => (
                                                <div
                                                    key={asset.sessionId || i}
                                                    className={`group flex items-start gap-2 px-2 py-1 rounded-lg ${activeSession?.sessionId === asset.sessionId ? "bg-primary-50 border border-primary-200" : "hover:bg-white/80"}`}
                                                >
                                                    {/* ===== MAIN SESSION BUTTON ===== */}
                                                    <button
                                                        onClick={() =>
                                                            setActiveSession({
                                                                ...asset,
                                                                syllabusId: s.id,
                                                                index: i + 1,
                                                            })
                                                        }
                                                        className="flex-1 text-left flex items-start justify-between gap-3 px-2 py-2 transition"
                                                    >
                                                        {/* LEFT SIDE */}
                                                        <div className="flex items-start gap-3">
                                                            <div
                                                                className={`w-6 h-6 rounded-md flex items-center justify-center text-xs flex-shrink-0 ${activeSession?.sessionId === asset.sessionId ? "bg-primary-200" : "bg-gray-200"
                                                                    }`}
                                                            >
                                                                {getAssetIcon(asset?.type)}
                                                            </div>

                                                            <span className="text-sm font-medium break-words leading-snug">
                                                                {i + 1}. {asset.title}
                                                            </span>
                                                        </div>
                                                        {/* DURATION */}
                                                        <span className="text-[11px] bg-gray-100 px-2 py-[2px] rounded whitespace-nowrap">
                                                            {asset?.type === "video" && (
                                                                <VideoDuration url={`${BeURL}${asset?.file?.url}`} />
                                                            )}
                                                        </span>
                                                    </button>

                                                    {/* ===== ACTION BUTTONS (RIGHT SIDE) ===== */}
                                                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition">
                                                        <button onClick={() => handleEditSession(course?._id,s.id, asset._id)} className="text-xs text-blue-500 hover:text-red-700">
                                                            <FiEdit size={16} />
                                                        </button>
                                                        <button onClick={() => deleteSession(s.id, asset._id)} className="text-xs text-red-500 hover:text-red-700">
                                                            <RiDeleteBin6Line size={16} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Add Session Button (per-syllabus) */}
                                            <button
                                                onClick={() => openSessionModal(String(s.id))}
                                                className="w-full mt-2 text-xs py-2 rounded-md border border-dashed border-primary-300 text-primary-600 hover:bg-primary-50 transition"
                                            >
                                                + Add Session
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Syllabus Modal (unchanged) */}
            <Modal open={syllabusPopup} onClose={handleCloseModule} title={`${editModule?.type === "Edit" ? "Update Module" : "Create Module"}`}>
                <div className="space-y-5">
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">
                            Module Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            value={newSyllabusName}
                            onChange={handleNameChange}
                            placeholder="Enter module name"
                            className={`w-full border px-3 py-2.5 rounded-lg outline-none transition ${getSyllabusInputClass("name")}`}
                        />
                        {renderSyllabusError("name")}
                    </div>
                    
                    <div className="flex justify-end gap-3 pt-4 border-t">

                        <button onClick={handleCloseModule} className="px-4 py-2 border border-gray-300 rounded-lg">Cancel</button>

                        {editModule?.type === "Edit" ? (<button onClick={() => handleUpdateSyllabus(editModule)} disabled={creatingSyllabus} className="px-5 py-2 bg-primary-600 text-white rounded-lg">
                            {creatingSyllabus ? "Updating..." : "Update"}
                        </button>): (<button onClick = {handleCreateSyllabus} disabled = { creatingSyllabus } className = "px-5 py-2 bg-primary-600 text-white rounded-lg">
                            { creatingSyllabus? "Creating...": "Create" }
                        </button>)}
                    </div>
                </div>
            </Modal>

            {/* Session Modal (unchanged) */}
            <Modal open={!!sessionPopupFor} onClose={closeSessionModal} title={editModule?.type === "Edit" ? "Update Session" : "Create Session"}>
                <div className="space-y-4">
                    <div>
                        <select
                            value={selectedSyllabusId}
                            onChange={(e) => setSelectedSyllabusId(e.target.value)}
                            className="border px-3 py-2 rounded w-full"
                            disabled={editModule?.type === "Edit"}
                        >
                            <option value="">Select Module</option>

                            {course?.syllabuses?.map((s, index) => (
                                <option key={s.id || index} value={s.id}>
                                    Module {index + 1} - {s.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="text-sm font-medium">Title <span className="text-red-500">*</span></label>
                        <input
                            value={sessionTitle}
                            onChange={handleSessionTitleChange}
                            className={`w-full px-3 py-2 rounded border ${getSessionInputClass("title")}`}
                            placeholder="Enter session title"
                        />
                        {renderSessionError("title")}
                    </div>

                    <div>
                        <label className="text-sm font-medium">Description</label>
                        <textarea value={sessionDescription} onChange={handleSessionDescriptionChange} rows={3} className="w-full px-3 py-2 border rounded" />
                    </div>

                    <div className="flex gap-2">
                        <div className="flex-1">
                            <label className="text-sm font-medium">Type <span className="text-red-500">*</span></label>
                            <select
                                value={sessionType}
                                onChange={handleSessionTypeChange}
                                className={`w-full px-3 py-2 rounded border ${getSessionInputClass("type")}`}
                            >
                                <option value="">Select type</option>
                                <option value="video">Video</option>
                                <option value="pdf">PDF</option>
                            </select>
                            {renderSessionError("type")}
                        </div>

                    </div>
                
                    {/*Conditional file input depending on type */}
                    {sessionType === "video" && (
                        <div>
                            <label className="text-sm font-medium">Upload Video <span className="text-red-500">*</span></label>
                            <input type="file" accept="video/*" onChange={(e) => handleSessionFileChange(e, "video")} className={`w-full mt-1 ${getSessionInputClass("videoFile")}`} />
                            {sessionTouched.videoFile && sessionErrors.videoFile && <p className="text-xs text-red-500 mt-1">{sessionErrors.videoFile}</p>}
                            {videoFile && <p className="text-xs mt-1 text-gray-600">{videoFile.name || videoFile?.filename} • {(videoFile.size / (1024 * 1024)).toFixed(2)} MB</p>}
                        </div>
                    )}

                    {sessionType === "pdf" && (
                        <div>
                            <label className="text-sm font-medium">Upload PDF <span className="text-red-500">*</span></label>
                            <input type="file" accept="application/pdf" onChange={(e) => handleSessionFileChange(e, "pdf")} className={`w-full mt-1 ${getSessionInputClass("pdfFile")}`} />
                            {sessionTouched.pdfFile && sessionErrors.pdfFile && <p className="text-xs text-red-500 mt-1">{sessionErrors.pdfFile}</p>}
                            {pdfFile && <p className="text-xs mt-1 text-gray-600">{pdfFile.name || pdfFile?.filename} • {(pdfFile.size / (1024 * 1024)).toFixed(2)} MB</p>}
                        </div>
                    )}

                    {sessionType === "image" && (
                        <div>
                            <label className="text-sm font-medium">Upload Image <span className="text-red-500">*</span></label>
                            <input type="file" accept="image/*" onChange={(e) => handleSessionFileChange(e, "image")} className={`w-full mt-1 ${getSessionInputClass("imageFile")}`} />
                            {sessionTouched.imageFile && sessionErrors.imageFile && <p className="text-xs text-red-500 mt-1">{sessionErrors.imageFile}</p>}
                            {imageFile && <p className="text-xs mt-1 text-gray-600">{imageFile.name || imageFile?.filename} • {(imageFile.size / (1024 * 1024)).toFixed(2)} MB</p>}
                        </div>
                    )}

                    {sessionType === "description" && (
                        <div>
                            <p className="text-xs text-gray-500">This session type uses only text description (no file required).</p>
                        </div>
                    )}

                    <div className="flex justify-end gap-3 pt-2 border-t">
                        <button onClick={closeSessionModal} className="px-4 py-2 border rounded">Cancel</button>
                        {editModule?.type === "Edit" ? (
                            <button onClick={handleUpdateSession} disabled={uploadingSession || addingSessionState?.[sessionPopupFor]} className="px-4 py-2 bg-primary-600 text-white rounded disabled:opacity-60">
                                {uploadingSession || addingSessionState?.[sessionPopupFor] ? "Uploading..." : "Update Session"}
                            </button>
                        ) : (
                                <button onClick={handleCreateSession} disabled={uploadingSession || addingSessionState?.[sessionPopupFor]} className="px-4 py-2 bg-primary-600 text-white rounded disabled:opacity-60">
                                    {uploadingSession || addingSessionState?.[sessionPopupFor] ? "Uploading..." : "Create Session"}
                                </button>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
}